<template>
  <div class="debug" dir="ltr" v-if="isDevelopment">
    <div class="debug-title">
      <slot name="title">{{ title }}</slot>
    </div>
    <pre v-if="code" v-html="code"></pre>
    <pre v-if="$slots.default"><slot /></pre>
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      title?: string
      code?: string
    }>(),
    {
      title: "Debug"
    }
  )

  const isDevelopment = computed(() => process.env.NODE_ENV === "development")
</script>

<style scoped lang="scss">
  .debug {
    @apply text-left my-5 overflow-hidden w-full border border-neutral-200 bg-neutral-50 relative text-xs font-mono rounded-lg;

    pre {
      @apply whitespace-pre p-3 m-0 max-h-[400px] overflow-auto;
    }
    &-title {
      @apply w-full flex bg-neutral-100 border-0 border-b border-solid border-neutral-200 py-2.5 px-3 font-bold text-neutral-600;
    }
  }
</style>
